import axios from 'axios'

const submitData = async (request) => {
    const sendRequest = await axios.post('https://kuboto-backend.herokuapp.com/request', request)

    return sendRequest
}

export default submitData
